export default {
    login: 'post|/api/index/pubAuth',
    userInfo: 'post|/api/goods/getUser',
    sign: 'post|/api/index/status',

    getNoticeList: 'post|/api/goods/getNotice',
    getMainInfo: 'post|/api/goods/rule',

    getGroupList: 'post|/api/goods/groupList',
    getCoachList : 'post|/api/goods/coachList',
    useCoach: 'post|/api/goods/personal',
    cancelUseCoach: 'post|/api/goods/coachCancel',

    getMyGroup: 'post|/api/goods/myGroup',
    getMyPrivate: 'post|/api/goods/myPrivate',
    getStatis: 'post|/api/goods/userStatistics',
    getCoachStatis: 'post|/api/goods/coachStatistics',

    getMyOrderList: 'post|/api/goods/getOrder',

    getMyCarList: 'post|/api/goods/block',//我的卡包

    getGoodsList: 'post|/api/goods/getGoods',
    buyGoods: 'post|/api/goods/creatOder',

    setPhone: 'post|/api/goods/phone',

    join: 'post|/api/goods/reservation',
    cancelJoin: 'post|/api/goods/cancel',

    uploadFile: 'FORMDATA|/api/goods/imgUpload',

    changeUserTime: 'post|/api/goods/setTime',

    // 教练不可约时间
    coachBlock: 'post|/api/goods/coachBlock',
    coachUnblock: 'post|/api/goods/coachUnblock',
    coachBlocks: 'post|/api/goods/coachBlocks',
}
